<form [formGroup]="formGroup" class="form-container">
  @for (field of formFields; track field) {
    @if (!field.hidden && !(field.hidden$ | async)) {
      <div class="form-field" [ngClass]="'col-' + field.size">
        @switch (field.type) {
          @case ('template') {
            <div>
              <ng-container [ngTemplateOutlet]="field.template"></ng-container>
            </div>
          }
          @case ('text') {
            <div>
              <div class="text-div-field">
                <mat-form-field class="d-block full-width" appearance="outline">
                  <mat-label>{{
                    'forms:' + field.label | i18nextCap
                  }}</mat-label>
                  <input
                    matInput
                    [name]="field.name"
                    [formControlName]="field.name"
                    (blur)="onSelectChange($event)"
                    (keyup.enter)="onSelectChange($event)"
                    [matTooltip]="field.matTooltip | i18nextCap"
                    [attr.data-testid]="field?.dataTestId"
                  />
                  @if (field.helperText) {
                    <mat-hint>{{ field.helperText | i18nextCap }} </mat-hint>
                  }
                  @if (formGroup.controls[field.name]?.errors?.email) {
                    <mat-error
                      >{{ 'validation:emailMustBeProperValue' | i18nextCap }}
                    </mat-error>
                  }
                  @if (formGroup.controls[field.name]?.errors?.required) {
                    <mat-error
                      >{{ 'validation:youMustEnterAValue' | i18nextCap }}
                    </mat-error>
                  }
                </mat-form-field>
                @for (button of field.buttons; track button) {
                  <button
                    mat-icon-button
                    (click)="button.onClick ? button.onClick() : null"
                    color="primary"
                    type="button"
                    [matMenuTriggerFor]="button.matMenu || null"
                    [disabled]="
                      button.disabled$ ? (button.disabled$ | async) : undefined
                    "
                  >
                    <mat-icon>{{ button.iconName }}</mat-icon>
                  </button>
                }
              </div>
            </div>
          }
          @case ('textarea') {
            <div>
              <mat-form-field class="d-block full-width" appearance="outline">
                <mat-label>{{ 'forms:' + field.label | i18nextCap }}</mat-label>
                <textarea
                  matInput
                  [name]="field.name"
                  [formControlName]="field.name"
                  (blur)="onSelectChange($event)"
                  (keyup.enter)="onSelectChange($event)"
                ></textarea>
                <mat-error
                  >{{ 'validation:youMustEnterAValue' | i18nextCap }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          @case ('checkbox') {
            <div>
              <mat-checkbox
                class="full-width"
                [name]="field.name"
                [formControlName]="field.name"
                (change)="onSelectChange($event)"
                >{{ 'forms:' + field.label | i18nextCap }}
              </mat-checkbox>
            </div>
          }
          @case ('number') {
            <div>
              <mat-form-field class="d-block full-width" appearance="outline">
                <mat-label>{{ 'forms:' + field.label | i18nextCap }}</mat-label>
                <input
                  class="number"
                  matInput
                  type="number"
                  min="0"
                  step="1"
                  [name]="field.name"
                  [formControlName]="field.name"
                  (blur)="onInputChange()"
                  (keyup.enter)="onInputChange()"
                />
                <mat-error
                  >{{ 'validation:youMustEnterAValue' | i18nextCap }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          @case ('select') {
            <div>
              <crm-form-select
                class="full-width"
                [formGroup]="formGroup"
                [field]="field"
                (selectionChange)="onSelectChange($event)"
              ></crm-form-select>
            </div>
          }
          @case ('multiple-select') {
            <div>
              <div class="text-div-field multiple-select-field">
                <crm-form-select
                  class="full-width"
                  [formGroup]="formGroup"
                  [field]="field"
                  [multiple]="true"
                  (selectionChange)="onSelectChange($event)"
                ></crm-form-select>
              </div>
            </div>
          }
          @case ('fulldate') {
            <div>
              <crm-form-date
                class="full-width"
                [formGroup]="formGroup"
                [field]="field"
                (selectionChange)="onSelectChange($event)"
              ></crm-form-date>
            </div>
          }
          @case ('slide') {
            <div>
              <mat-slide-toggle
                class="full-width"
                [name]="field.name"
                [formControlName]="field.name"
                (change)="onSelectChange($event)"
                color="primary"
              >
                {{ 'forms:' + field.label | i18nextCap }}
              </mat-slide-toggle>
            </div>
          }
          @case ('autocomplete') {
            <div>
              <crm-form-autocomplete
                class="full-width"
                [formGroup]="formGroup"
                [field]="field"
              ></crm-form-autocomplete>
            </div>
          }
          @case ('chips-autocomplete') {
            <div>
              <crm-form-chips-autocomplete
                [formGroup]="formGroup"
                [field]="field"
              ></crm-form-chips-autocomplete>
            </div>
          }
          @case ('date') {
            <div>
              <crm-form-date
                class="full-width"
                [dateOnly]="true"
                [formGroup]="formGroup"
                [field]="field"
                (selectionChange)="onSelectChange($event)"
              ></crm-form-date>
            </div>
          }
          @case ('upload') {
            <div>
              <mat-form-field class="d-block full-width" appearance="outline">
                <mat-label>{{ 'forms:' + field.label | i18nextCap }}</mat-label>
                <input
                  matInput
                  [name]="field.name"
                  [formControlName]="field.name"
                  class="icon"
                />
                <input
                  style="display: none"
                  type="file"
                  (change)="uploadPDF($event, field.name)"
                  #fileInput
                />
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  color="primary"
                  (click)="fileInput.click()"
                >
                  <mat-icon>publish</mat-icon>
                </button>
                <mat-error
                  >{{ 'validation:youMustEnterAValue' | i18nextCap }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          @case ('price') {
            <div>
              <mat-form-field class="d-block full-width" appearance="outline">
                <mat-label>{{ 'forms:' + field.label | i18nextCap }}</mat-label>
                <span class="currency" matSuffix>€ &nbsp;</span>
                <input
                  class="price"
                  matInput
                  type="number"
                  [name]="field.name"
                  [formControlName]="field.name"
                />
                <mat-error
                  >{{ 'validation:youMustEnterAValue' | i18nextCap }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          @case ('images') {
            <div>
              <crm-input-images
                class="full-width"
                [field]="field"
                [formGroup]="formGroup"
              ></crm-input-images>
            </div>
          }
          @default {
            <div class="field-not-found">{{ field.name }}Field Not Found</div>
          }
        }
      </div>
    }
  }
</form>

<!-- Aqui -->

<!-- <form [formGroup]="formGroup">
<ng-container *ngFor="let field of row; let i = index">
  <mat-grid-tile
      *ngIf="
        ![
          'text',
          'textarea',
          'number',
          'fulldate',
          'select',
          'multiple-select',
          'checkbox',
          'slide',
          'autocomplete',
          'date',
          'upload',
          'price',
          'images'
        ].includes(field.type)
      "
    [colspan]="field.size"
    [style.background]="'lightblue'"
    >{{ i }} {{ field.size }} {{ field.type }}
  </mat-grid-tile>
  <ng-container [ngSwitch]="field.type" *ngIf="!field.hidden && !(field.hidden$ | async)">
    <mat-grid-tile
      *ngSwitchCase="'textarea'"
      [rowspan]="2"
      [colspan]="field.size"
      >
      <mat-form-field class="d-block full-width" appearance="outline">
        <mat-label>{{ 'forms:' + field.label | i18nextCap }}</mat-label>
        <textarea
          matInput
          [name]="field.name"
          [formControlName]="field.name"
          (blur)="onSelectChange($event)"
          (keyup.enter)="onSelectChange($event)"
        ></textarea>
        <mat-error
          >{{ 'validation:youMustEnterAValue' | i18nextCap }}
        </mat-error>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile *ngSwitchCase="'checkbox'" [colspan]="field.size">
      <mat-checkbox
        class="full-width"
        [name]="field.name"
        [formControlName]="field.name"
        (change)="onSelectChange($event)"
        >{{ 'forms:' + field.label | i18nextCap }}
      </mat-checkbox>
    </mat-grid-tile>
    <mat-grid-tile *ngSwitchCase="'number'" [colspan]="field.size">
      <mat-form-field class="d-block full-width" appearance="outline">
        <mat-label>{{ 'forms:' + field.label | i18nextCap }}</mat-label>
        <input
          class="number"
          matInput
          type="number"
          min="0"
          step="1"
          [name]="field.name"
          [formControlName]="field.name"
          (blur)="onInputChange()"
          (keyup.enter)="onInputChange()"
          />
        <mat-error
          >{{ 'validation:youMustEnterAValue' | i18nextCap }}
        </mat-error>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile *ngSwitchCase="'select'" [colspan]="field.size">
      <crm-form-select
        class="full-width"
        [formGroup]="formGroup"
        [field]="field"
        (selectionChange)="onSelectChange($event)"
      ></crm-form-select>
    </mat-grid-tile>
    <mat-grid-tile *ngSwitchCase="'multiple-select'" [colspan]="field.size">
      <crm-form-select
        class="full-width"
        [formGroup]="formGroup"
        [field]="field"
        [multiple]="true"
        (selectionChange)="onSelectChange($event)"
      ></crm-form-select>
    </mat-grid-tile>
    <mat-grid-tile *ngSwitchCase="'fulldate'" [colspan]="field.size">
      <crm-form-date
        class="full-width"
        [formGroup]="formGroup"
        [field]="field"
        (selectionChange)="onSelectChange($event)"
      ></crm-form-date>
    </mat-grid-tile>
    <mat-grid-tile *ngSwitchCase="'slide'" [colspan]="field.size">
      <mat-slide-toggle
        class="full-width"
        [name]="field.name"
        [formControlName]="field.name"
        (change)="onSelectChange($event)"
        color="primary"
        >
        {{ 'forms:' + field.label | i18nextCap }}
      </mat-slide-toggle>
    </mat-grid-tile>
    <mat-grid-tile *ngSwitchCase="'autocomplete'" [colspan]="field.size">
      <crm-form-autocomplete
        class="full-width"
        [formGroup]="formGroup"
        [field]="field"
      ></crm-form-autocomplete>
    </mat-grid-tile>
    <mat-grid-tile
      *ngSwitchCase="'chips-autocomplete'"
      [colspan]="field.size"
      >
      <crm-form-chips-autocomplete
        [formGroup]="formGroup"
        [field]="field"
      ></crm-form-chips-autocomplete>
    </mat-grid-tile>
    <mat-grid-tile *ngSwitchCase="'date'" [colspan]="field.size">
      <crm-form-date
        class="full-width"
        [dateOnly]="true"
        [formGroup]="formGroup"
        [field]="field"
        (selectionChange)="onSelectChange($event)"
      ></crm-form-date>
    </mat-grid-tile>
    <mat-grid-tile *ngSwitchCase="'upload'" [colspan]="field.size">
      <mat-form-field class="d-block full-width" appearance="outline">
        <mat-label>{{ 'forms:' + field.label | i18nextCap }}</mat-label>
        <input
          matInput
          [name]="field.name"
          [formControlName]="field.name"
          class="icon"
          />
        <input
          style="display: none"
          type="file"
          (change)="uploadPDF($event, field.name)"
          #fileInput
          />
        <button
          mat-icon-button
          matSuffix
          type="button"
          color="primary"
          (click)="fileInput.click()"
          >
          <mat-icon>publish</mat-icon>
        </button>
        <mat-error
          >{{ 'validation:youMustEnterAValue' | i18nextCap }}
        </mat-error>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile *ngSwitchCase="'price'" [colspan]="field.size">
      <mat-form-field class="d-block full-width" appearance="outline">
        <mat-label>{{ 'forms:' + field.label | i18nextCap }}</mat-label>
        <span class="currency" matSuffix>€ &nbsp;</span>
        <input
          class="price"
          matInput
          type="number"
          [name]="field.name"
          [formControlName]="field.name"
          />
        <mat-error
          >{{ 'validation:youMustEnterAValue' | i18nextCap }}
        </mat-error>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile
      *ngSwitchCase="'images'"
      [rowspan]="3"
      [colspan]="field.size"
      >
      <crm-input-images
        class="full-width"
        [field]="field"
        [formGroup]="formGroup"
      ></crm-input-images>
    </mat-grid-tile>
    <mat-grid-tile *ngSwitchCase="'autocomplete-list'" [colspan]="field.size">
      <crm-form-autocomplete-list
        [formGroup]="formGroup"
        [field]="field"
      ></crm-form-autocomplete-list>
    </mat-grid-tile>
  </ng-container>
</ng-container>
</form> -->
